export default {
  providers: ['facebook', 'twitter', 'linkedin'],
  hashtag: 'BiznisNET',
  // use placeholders to interpolate presentation variables
  // {title} - presentation title
  message: 'BiznisNET – expandujte do zahraničia',
  url: 'https://www.npc.sk/sk/events/biznisnet_2_2020/',
}



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/addons/socialShare/presentation.js